export const iconBaseUrl = '/assets/img/icons/';
export const iconBaseType = 'svg';
